import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {CommonsModule} from "../../commons/angular/commons.module";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {TranslateModule} from "@ngx-translate/core";
import {NgxPermissionsModule} from "ngx-permissions";
import {AccountsModule} from "../../account/angular/accounts.module";
import {AgentsModule} from "../../agents/angular/agents.module";
import {AddressesModule} from "../../addresses/angular/addresses.module";
import {PackageSpotsPipe} from "../../commons/angular/pipes/package-spots.pipe";
import {LogisticsVehicleModule} from "../../logistics-vehicle/angular/logistics-vehicle.module";
import {CdkDrag, DragDropModule} from "@angular/cdk/drag-drop";
import {ScrollingModule as ScrollingModuleExperimental} from "@angular/cdk-experimental/scrolling";
import {ResourcesPanelListComponent} from "./components/resources-panel-list/resources-panel-list.component";
import {ResourcesTableListComponent} from "./components/resources-table-list/resources-table-list.component";
import {ResourcesTableListRowComponent} from "./components/resources-table-list-row/resources-table-list-row.component";
import {
  ResourcesPanelListItemComponent
} from "./components/resources-panel-list-item/resources-panel-list-item.component";


@NgModule({
  declarations: [
    ResourcesPanelListComponent,
    ResourcesTableListComponent,
    ResourcesTableListRowComponent,
    ResourcesPanelListItemComponent,
  ],
  imports: [
    BrowserModule,
    CommonsModule,
    NgbModule,
    ScrollingModule,
    ScrollingModuleExperimental,
    AccountsModule,
    AgentsModule,
    LogisticsVehicleModule,
    AddressesModule,
    DragDropModule,
    TranslateModule.forChild(),
    NgxPermissionsModule.forChild(),
    CdkDrag
  ],
    exports: [
        ResourcesPanelListItemComponent,
        ResourcesTableListComponent,
        ResourcesTableListRowComponent
    ],
  providers: [
    PackageSpotsPipe
  ]
})

export class ResourcesModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapResourcesModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(ResourcesModule);
};

export const downgradedResourcesModule = downgradeModule(bootstrapResourcesModule);
